<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>


<script>
  export default {
    name: "Main",
    data () {
      return {}
    }
  }
</script>



// WEBPACK FOOTER //
// src/Main.vue